import {ApiEnum, ApiEnumItem} from '../../../types/ApiEnum';

/**
 * Function will return the highest parent of the given key
 * @param key key of feature, we are looking it's the highest parent
 * @param features list of all features from catalogue
 */
export const findTopMostItem = (key: string, features?: ApiEnum): ApiEnumItem | undefined => {
  const findRecursive = (nodes: ApiEnum): boolean =>
    nodes?.some((item) => item.value === key || (item.children && findRecursive(item.children)));

  return features?.find(
    (feat) => feat.value === key || (feat.children && findRecursive(feat.children))
  );
};
